import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { BottlesPage } from './pages/BottlesPage';
import { BottleAddPage } from './pages/BottleAddPage';
import { BottleAttributesPage } from './pages/BottleAttributesPage';
import { ServiceDashboardPage } from './pages/ServiceDashboardPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ServiceOperatorProtectedRoute } from './components/ServiceOperatorProtectedRoute';
import { useAuthStore } from './stores/authStore';
import './App.css';

function App() {
  const { checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route 
            path="/bottles" 
            element={
              <ProtectedRoute>
                <BottlesPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/bottles/add" 
            element={
              <ProtectedRoute>
                <BottleAddPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/bottles/attributes" 
            element={
              <ProtectedRoute>
                <BottleAttributesPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/bottles/:bottleId/attributes" 
            element={
              <ProtectedRoute>
                <BottleAttributesPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/service/dashboard" 
            element={
              <ServiceOperatorProtectedRoute>
                <ServiceDashboardPage />
              </ServiceOperatorProtectedRoute>
            } 
          />
          <Route path="/" element={<Navigate to="/bottles" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
